

export const SET_ERROR = "@invoice/SET_ERROR";
export const RESET_ERROR = "@invoice/RESET_ERROR";
export const SET_ERROR_MESSAGE = "@invoice/SET_ERROR_MESSAGE";

export const SET_SELECTED_ID = "@invoice/SET_SELECTED_ID";
export const RESET_SELECTED_ID = "@invoice/RESET_SELECTED_ID";